import React, { useState, createContext } from "react";

import { defaultThumbnail } from "../../theme/uploaded";

export const PlayerStateContext = createContext();

const INIT_PLAYER_STATE = {
  isPlaying: false,
  playbackCovered: 0,
  playbackLength: 0,
  currentSongIndex: 0,
  time: "",
  queue: [],
  thumbnail: defaultThumbnail,
  title: "Play a song",
};

export const PlayerStateProvider = (props) => {
  const [playerState, setPlayerState] = useState(INIT_PLAYER_STATE);
  return (
    <PlayerStateContext.Provider value={[playerState, setPlayerState]}>
      {props.children}
    </PlayerStateContext.Provider>
  );
};
